export default __webpack_public_path__ + "static/nasta-niva-167dbc05f98cd4fac5cc8fe95a8e5e91.jpg";